// extracted by mini-css-extract-plugin
export default {"ProDetailListTop":"ProDetailListTop_ProDetailListTop__wp0Xb","head":"ProDetailListTop_head__1W9gH","project_name":"ProDetailListTop_project_name__kui9E"};